export const documentsPageStyles = {
  container: {
    paddingTop: 'var(--mantine-spacing-xl)',
    paddingBottom: 'var(--mantine-spacing-xl)',
  },
  documentCard: {

    border: '2px solid #002f2f',
    outline: '5px solid #002f2f',
    outlineOffset: '2px',
    borderRadius: '10px',
    padding: 'var(--mantine-spacing-md)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    color: '#002f2f',
  },
}